import { memo, useMemo } from 'react'
import { OIChart } from './OIChart'
import { OI_CHART_META_INFO, oiChartDataEqual, OiChartRow } from './oiChartData'
import { SegmentInfo } from '../participantOpenInterest'

type Props = {
    chartData: OiChartRow[]
    showOI: boolean
    replayKey: number
    compactBars?: boolean
}

const OiAnalysisChartPanel = ({ chartData, showOI, replayKey, compactBars }: Props) => {
    const segmentInfo: SegmentInfo = useMemo(
        () => ({
            metaInfo: OI_CHART_META_INFO,
            data: chartData,
            leftScaleData: [],
            displayName: '',
        }),
        [chartData]
    )

    return (
        <OIChart
            segmentInfo={segmentInfo}
            showOI={showOI}
            replayKey={replayKey}
            compactBars={compactBars}
        />
    )
}

export default memo(OiAnalysisChartPanel, (prev, next) => {
    if (
        prev.showOI !== next.showOI ||
        prev.replayKey !== next.replayKey ||
        prev.compactBars !== next.compactBars
    ) {
        return false
    }
    return oiChartDataEqual(prev.chartData, next.chartData)
})
